import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  gap: 24px;\n  margin-bottom: 64px;\n\n  body:has(&) {\n    .gnb {\n      position: unset;\n    }\n\n    .fixed {\n      position: unset;\n      top: unset;\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  width: 204px;\n  height: calc(100vh - 12px);\n  padding: 32px 16px 0 0;\n  position: sticky;\n  top: 0;\n  transition: top 0.3s ease;\n  overflow-y: auto;\n\n  &::-webkit-scrollbar {\n    width: 3px;\n    height: 140px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    border-radius: 2px;\n    background: rgba(206, 210, 224, 1);\n  }\n\n  @media (max-width: 768px) {\n    display: none;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  width: calc(100% - 204px);\n  flex: 1;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CategoryList, Container } from "@/components";
import { BreadCrumbItem, CategoryBreadCrumbView } from "@/components/Categories/Menu/CategoryBreadCrumbView";
import { CategoryTreeView, ChevronDown, ChevronUp } from "@/components/Categories/Menu/CategoryTree";
import { CategoryTreeItem } from "@/components/Categories/Menu/CategoryTreeItem";
import { FilterQueryHandlerType, useCategoryFilterHandler } from "@/hooks/useCategoryFilterHandler";
import { useCategoryTree } from "@/hooks/useCategoryTree";
import { useHandleTreeView } from "@/hooks/useHandleTreeView";
import { usePagination } from "@/hooks/usePaginationNew";
import { Typography, styled } from "@mui/material";
import { useTreeViewApiRef } from "@mui/x-tree-view";
import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { CategoryQueryKey, DetailFilterKeys, getCategoryList, getCategoryMenu } from "../../api/category";
const LIMIT = 24;
export const DEFAULT_QUERY_SIZE = 1;
const CategoryPage = ()=>{
    var _categoryMenu_depthItems__items_, _categoryMenu_depthItems_, _findCategoryChildren, _categoryDepthNameList_;
    const { filterQueryHandler , searchParams , hasSelectedFilter  } = useCategoryFilterHandler();
    const { data: categoryMenu  } = useQuery([
        "categoryMenu"
    ], ()=>getCategoryMenu(), {});
    var _searchParams_get;
    const categoryId = (_searchParams_get = searchParams.get(CategoryQueryKey.CATEGORY)) !== null && _searchParams_get !== void 0 ? _searchParams_get : (_categoryMenu_depthItems__items_ = (_categoryMenu_depthItems_ = categoryMenu === null || categoryMenu === void 0 ? void 0 : categoryMenu.depthItems[0]) === null || _categoryMenu_depthItems_ === void 0 ? void 0 : _categoryMenu_depthItems_.items[0]) === null || _categoryMenu_depthItems__items_ === void 0 ? void 0 : _categoryMenu_depthItems__items_.id;
    const { data: { id: queriedCategoryId , data: categoryList  } = {} , isLoading , isSuccess  } = useQuery([
        "categoryList",
        categoryId,
        searchParams.toString()
    ], ()=>getCategoryList({
            sort: searchParams.get(CategoryQueryKey.SORT),
            id: categoryId,
            "authors[]": searchParams.getAll(DetailFilterKeys.AUTHORS),
            "dataTypes[]": searchParams.getAll(DetailFilterKeys.DATATYPES),
            "units[]": searchParams.getAll(DetailFilterKeys.UNITS),
            "solvookPasses[]": searchParams.getAll(DetailFilterKeys.SOLVOOKPASS),
            offset: offset,
            limit: LIMIT
        }), {
        enabled: !!categoryId,
        keepPreviousData: true,
        select: (data)=>{
            return {
                id: categoryId,
                data
            };
        }
    });
    var _categoryList_totalCount;
    const { offset , ...paginationProps } = usePagination({
        limit: LIMIT,
        totalCount: (_categoryList_totalCount = categoryList === null || categoryList === void 0 ? void 0 : categoryList.totalCount) !== null && _categoryList_totalCount !== void 0 ? _categoryList_totalCount : 0
    });
    const { treeData , categoryDepthNameList , currentDepth , findCategoryChildren , isLastDepth  } = useCategoryTree({
        categoryMenu,
        categoryId
    });
    const apiRef = useTreeViewApiRef();
    const { expandedItems , handleSelectedItemsChange , handleExpandedItemsChange , selectedItem  } = useHandleTreeView({
        categoryId,
        categoryMenu: categoryMenu === null || categoryMenu === void 0 ? void 0 : categoryMenu.depthItems
    });
    const handleBreadCrumbs = (id)=>{
        filterQueryHandler({
            filterType: FilterQueryHandlerType.CATEGORY,
            value: id
        });
    //TODO: usehandletreeview에서 useeffect로 처리
    // 지금의 함수로 처리를 훅으로 변경하고자 하는 이유가 궁금합니다
    // handleExpandedItemsChange(null, [...findParents(id), checkLastDepth(id) ? '' : id])
    // handleSelectedItemsChange(null, [id])
    };
    const breadcrumbList = categoryDepthNameList.map((item, idx)=>{
        if (idx === 0) return;
        return /*#__PURE__*/ _jsx(BreadCrumbItem, {
            depth: idx,
            onClick: ()=>handleBreadCrumbs(item.id),
            item: item,
            list: categoryDepthNameList
        }, item.id);
    });
    const router = useRouter();
    useEffect(()=>{
        if (!isSuccess) return;
        if (queriedCategoryId !== searchParams.get("id")) return;
        if (Array.from(searchParams.keys()).length > DEFAULT_QUERY_SIZE) return;
        const findFilterItem = categoryList === null || categoryList === void 0 ? void 0 : categoryList.filterItems.find((filterItem)=>filterItem.name === DetailFilterKeys.UNITS);
        if (findFilterItem && findFilterItem.items.length) {
            router.push("/categories?id=".concat(searchParams.get("id"), "&단원=").concat(findFilterItem.items[0]));
        }
    }, [
        isSuccess,
        searchParams.get("id"),
        queriedCategoryId
    ]);
    return /*#__PURE__*/ _jsxs(CategoryNextPageContainer, {
        children: [
            /*#__PURE__*/ _jsxs(CategoryLNBSection, {
                children: [
                    categoryMenu && /*#__PURE__*/ _jsxs(Typography, {
                        variant: "subtitle1",
                        sx: {
                            marginBottom: "16px"
                        },
                        children: [
                            (_findCategoryChildren = findCategoryChildren(1)) === null || _findCategoryChildren === void 0 ? void 0 : _findCategoryChildren.name,
                            " 카테고리"
                        ]
                    }),
                    /*#__PURE__*/ _jsx(CategoryTreeView, {
                        apiRef: apiRef,
                        slots: {
                            item: CategoryTreeItem,
                            expandIcon: ChevronUp,
                            collapseIcon: ChevronDown
                        },
                        items: treeData,
                        expandedItems: expandedItems,
                        selectedItems: selectedItem,
                        onSelectedItemsChange: handleSelectedItemsChange,
                        onExpandedItemsChange: handleExpandedItemsChange
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(CategoryContentsSection, {
                children: [
                    /*#__PURE__*/ _jsx(CategoryBreadCrumbView, {
                        breadcrumbList: breadcrumbList,
                        currentDepth: currentDepth,
                        findCategoryChildren: findCategoryChildren,
                        handleCategoryMenu: handleBreadCrumbs,
                        isLastDepth: isLastDepth
                    }),
                    categoryMenu && /*#__PURE__*/ _jsx(CategoryList, {
                        ...categoryList,
                        ...paginationProps,
                        limit: LIMIT,
                        isLoadingListItem: isLoading,
                        categoryName: (_categoryDepthNameList_ = categoryDepthNameList[categoryDepthNameList.length - 1]) === null || _categoryDepthNameList_ === void 0 ? void 0 : _categoryDepthNameList_.name
                    })
                ]
            })
        ]
    });
};
export default CategoryPage;
const CategoryNextPageContainer = styled(Container)(_templateObject());
const CategoryLNBSection = styled("section")(_templateObject1());
const CategoryContentsSection = styled("section")(_templateObject2());
